export var CreditOperation;
(function (CreditOperation) {
    CreditOperation["ADD"] = "add_credit";
    CreditOperation["REMOVE"] = "remove_credit";
})(CreditOperation || (CreditOperation = {}));
